import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ServicePlan } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseQueryOptions<unknown, Error, ServicePlan[]>, 'queryKey' | 'queryFn'>
}

export const useSensorServicePlansRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, ServicePlan[]>(
    [Entities.Sensors, 'service-plans'],
    async () => {
      const { data } = await api.v1AdminSensorsServicePlansGet()
      return data as ServicePlan[]
    },
    options
  )
}
